import SearchIcon from '@mui/icons-material/Search';
import { CardHeader } from '@mui/material';
import { DEBOUNCE_ONE_SECOND } from 'common/constants';
import { useForm } from 'react-hook-form';
import { debounce } from 'utils/debounce';
import { clearFilterGroup, setFilterCurrentPage, setFilterGroupName } from 'v3/data/store/group/actions';
import { IFilters } from 'v3/data/store/group/types';
import { MiniButton } from 'v3/shared/components/Button/MiniButton';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import { BodyLarge } from 'v3/shared/typography/BodyLarge';
import { CardContentStyled, CardStyled } from './styles';

export const GroupsFilter = () => {
  const { control, reset, setValue } = useForm<IFilters>({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const handleOnchangeGroupName = (searchGroupName: string) => {
    debounce(
      () => {
        setFilterGroupName(searchGroupName);
        setFilterCurrentPage(0);
      },
      DEBOUNCE_ONE_SECOND,
      'handleSearchGroupName',
    );
  };

  const handleClearFilter = async () => {
    setValue('name', '');
    clearFilterGroup();
    reset();
  };

  return (
    <CardStyled>
      <CardHeader title={<BodyLarge>Filtro</BodyLarge>} />
      <CardContentStyled>
        <InputFormController
          data-testid="input-name"
          formControl={control}
          formControlName="name"
          placeholder="Procurar por nome"
          fullWidth
          onChangeInput={handleOnchangeGroupName}
          startAdornmentIcon={SearchIcon}
        />
        <MiniButton text="Limpar" $backgroundColor="transparent" handleClick={handleClearFilter} />
      </CardContentStyled>
    </CardStyled>
  );
};
